module.exports = __webpack_public_path__ + "img/paper_plus.dba364da.svg";